import consumer from "./consumer";
import { Turbo } from "@hotwired/turbo-rails";
import $ from "jquery";

const matches = window.location.href.match(/bulk_approvals\/(\d+)/);
let channel = null;
if (matches != null && matches[1]) {
  // Handle Turbo Stream refresh actions
  document.addEventListener("turbo:before-stream-render", (event) => {
    const { action } = event.detail.newStream;

    if (action === "refresh") {
      event.preventDefault();
      let href = window.location.href;
      if (!href.match(/\?bulk_operation/)) {
        href += "?bulk_operation=true";
      }
      Turbo.visit(href, { action: "replace" });
    }
  });

  channel = consumer.subscriptions.create(
    { channel: "BulkApprovalChannel", id: matches[1] },
    {
      connected() {
        console.log("Connected to bulk approval channel");
      },
      disconnected() {
        console.log("Disconnected from bulk approval channel");
      },
      rejected() {
        console.error("Connection rejected");
      },
      updateEntity(newEntityId) {
        this.perform("update_entity_for_transaction", {
          transaction_id: this.currentTransactionId,
          new_entity_id: newEntityId,
        });
      },

      currentTransactionId: null,
    },
  );

  window.setupEntitySelectEvents = function () {
    initContributionDetailsButton("data-entity-search-entity-id");
    $("a[data-selected-entity-id]").click(function (e) {
      channel.updateEntity($(this).attr("data-selected-entity-id"));
      $("#entity-search-modal").modal("hide");
      e.preventDefault();
    });
  };

  window.replaceBulkApprovalEntity = function (bulkApprovalTransactionId) {
    channel.currentTransactionId = bulkApprovalTransactionId;
    $("#entity-search-modal").modal("show");
  };
}
